<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :hide-overlay="$vuetify.breakpoint.xsOnly"
    scrollable
    max-width="600px"
    :content-class="$vuetify.breakpoint.smAndUp ? 'rounded-dialog' : ''"
  >
    <ApplicationForm
      v-if="show && opportunity && opportunity.id"
      :opportunity="opportunity"
      :width="$vuetify.breakpoint.mdAndUp ? '600px' : '100%'"
      :height="$vuetify.breakpoint.smAndUp ? '80vh' : '100%'"
      @close="show = false"
    />
  </v-dialog>
</template>

<script>
import ApplicationForm from '@/components/candidate/applications/ApplicationForm'

export default {
  components: { ApplicationForm },

  props: {
    value: { type: Boolean, default: false },
    opportunity: { type: Object, required: true },
  },

  data() {
    return {
      show: this.value,
    }
  },

  watch: {
    value: function(val) {
      this.show = val
    },
    show: function(val) {
      this.$emit('input', !!val)
    },
  },
}
</script>
